<div *ngIf="authService.isAuthenticated() && authService.checkRole(['admin'])" class="copy-link" (click)='copyLink();'></div>
<!-- <div class="canvas" (window:resize)="windowOnResize()"><canvas #canvas style="background-color:white;width: 100%;height:100%"></canvas></div> -->

<div (window:resize)="windowOnResize()">
  <app-signal-viewer-comp  class="canvas" (window:resize)="windowOnResize()" #singleView [callback]="theBoundCallback"></app-signal-viewer-comp>
  </div>

